import { Component, EventEmitter, Input, Output } from '@angular/core';
import { get } from 'lodash';

import { DetailActionCheck } from '../detail-dialog/detail-dialog.types';

import { MenuItemType } from './detail-action-buttons.const';
import { MenuItem } from './detail-action-buttons.types';

import { MeetingItem } from '~/repositories/meeting/store/meeting.models';
import { PANELMENUTYPES } from '~/ui/panel-menu/panel-menu.const';

@Component({
  selector: 'app-detail-action-buttons',
  templateUrl: './detail-action-buttons.component.html',
  styleUrl: './detail-action-buttons.component.scss',
  standalone: false
})
export class DetailActionButtonsComponent {
  @Input() items: MenuItem[];
  @Input() itemClass: string = '';
  @Input() checkedItems: MeetingItem[];
  @Input() buttonType: 'link' | 'button' = 'link';

  @Output() itemClick: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();
  @Output() endAction: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  MenuItemType = MenuItemType;

  itemShouldBeDisabled(item: MenuItem): boolean {
    const checks = get(item, ['typeOptions', 'action', 'config', 'checks'], null);
    if (!checks || item.disabled) {
      return item.disabled;
    }

    let hasInvalidChecks = false;

    checks.forEach((check: DetailActionCheck) => {
      if (hasInvalidChecks) {
        return;
      }

      switch (check.code) {
        case 'MIN_AMOUNT': {
          if (
            (this.checkedItems?.filter((item) => item.type === PANELMENUTYPES.AGENDAPAGE && !item.acceptable).length ||
              0) < (check.value as number)
          ) {
            hasInvalidChecks = true;
            break;
          }
          break;
        }
        //TODO: add more checks if needed
        default:
          break;
      }
    });

    return hasInvalidChecks;
  }
}
